import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
export const deleteChecklistItem = (task_id, checklist_id) => {

    return new Promise(async resolve => {
        try {
            const token = Cookies.get('Bearer');
            const response = await axios.delete(`${FIRMFLOWURL}api/ServiceTaskChecklist`,
                {
                    headers: { 'Authorization': token },
                    data: {
                        "serviceTaskId": task_id,
                        "serviceTaskChecklistItemId": checklist_id
                    }
                }
            )
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err)
            if (err.message.includes(401)) {
                Cookies.remove('Bearer');
                window.location.replace('/');
                return;
            }
            resolve({ success: false, message: err.message });
        }
    })
}